import { jwtDecode } from "jwt-decode"
import { TokenPayload } from "@/hooks/init/type"
export const getTokenPayload = (token: string): TokenPayload => {
  try {
    const payload = jwtDecode<TokenPayload>(token)

    return payload
  } catch (err) {
    throw Error(String(err))
  }
}
